import { render, staticRenderFns } from "./ViewerSidebar.vue?vue&type=template&id=6421cb70"
import script from "./ViewerSidebar.vue?vue&type=script&lang=js"
export * from "./ViewerSidebar.vue?vue&type=script&lang=js"
import style0 from "./ViewerSidebar.vue?vue&type=style&index=0&id=6421cb70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports